module.exports = __webpack_public_path__ + "img/open-book-gray.2ca890dd.svg";